import { Link, NavLink } from 'react-router-dom';
import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';

export const TabButtonHeader = styled.h3<{ highlighted: boolean }>`
  font-family: ${props => props.theme.fonts.circular} !important;
  font-size: ${props => props.theme.fontSizes.small} !important;
  font-weight: ${props => props.theme.fontWeights.semiBold} !important;
  letter-spacing: ${props => props.theme.letterSpacings.normal} !important;
  color: ${(props: any) =>
    props.highlighted ? props.theme.colors.capsuleBlue50 : props.theme.colors.capsuleGreen60} !important;

  padding: 0 !important;
  text-align: center;
`;

export const TabbedButtonContainer = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: ${props => props.theme.space['0.7']} !important;
  text-decoration: none !important;
  position: relative;
`;

export const NavLinkOverlay = styled(NavLink)`
  display: flex;
  position: relative;
`;

export const ArrowIcon = styled(InlineSVG)<{ raw: boolean }>`
  cursor: pointer;
  width: ${props => props.theme.space.s8};

  height: ${props => props.theme.space.s6};

  bottom: ${props => props.theme.space.s2};
  right: -${props => props.theme.space.s8};
  ${props => props.theme.mediaQueries.smallDown} {
    bottom: ${props => props.theme.space['10.0']};
    right: unset;
    transform: rotate(270deg);
  }

  /* IPhone SE Handling or Devices with a height below 575px */
  ${props => props.theme.mediaQueries.smallWidthAndHeightDown} {
    bottom: ${props => props.theme.space['11.5']};
    right: unset;
  }

  position: absolute;
  z-index: ${props => props.theme.zIndices.overlayMore};
`;

export const PositionedBottomCenter = styled.div`
  position: absolute;
  bottom: ${props => props.theme.space.s3};
  left: 50%;
  transform: translateX(-50%);
`;
